import { render, staticRenderFns } from "./memorabilia.vue?vue&type=template&id=899a0b90&scoped=true"
import script from "./memorabilia.vue?vue&type=script&lang=js"
export * from "./memorabilia.vue?vue&type=script&lang=js"
import style0 from "./memorabilia.vue?vue&type=style&index=0&id=899a0b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899a0b90",
  null
  
)

export default component.exports